@use "@fukuri-admins/ui/layout" as *;

.title {
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
  text-transform: uppercase;
  margin-bottom: 16px;
  color: #676370;
}

.tableContainer {
  height: 720px;
  max-height: 90vh;
  border-bottom: 1px solid $Border;

  &.MuiTableContainer-root {
    border: none;
    padding: 0px;
    margin-bottom: 20px;

    .MuiTableRow-root {
      border-bottom: 1px solid #eee;
      cursor: pointer;

      &:hover {
        background: #eee;
      }
    }

    .MuiTableBody-root .MuiTableRow-root:last-child {
      border-bottom: solid 1px transparent;
    }
  }

  .MuiTableCell-root {
    white-space: nowrap;
    border-bottom: none;
  }
}

.tableContent {
  &.MuiTableHead-root {
    width: 900px;
    min-width: 100%;
    table-layout: auto;
  }
}

.tableHeaderCell {
  cursor: pointer;
  font-size: 14px;
  font-weight: 600 !important;
  color: #797f7f !important;
  background-color: #e8e8e8 !important;
  border-right: 1px solid #ffffff !important;
  transition: all 0.3s ease-out;
  padding: 12px 20px !important;

  &:hover {
    background: #eee !important;
  }

  &:last-child {
    border-right: none;
  }
}

.tableCell {
  line-height: 54px;
  font-size: 16px;
  font-family: "Noto Sans JP";
  color: white;
  font-weight: normal;
}

.tableHeaderCellDiv {
  display: flex;
  align-items: center;
  gap: 8px;
}

.justifyContentCenter {
  justify-content: center;
}

.disabled {
  color: #ccc;
}

.sortIconActive {
  color: #041615;
}

.sortIconInactive {
  color: #ccc;
}
